const PUBLIC_API_PATTERNS = [
  '/api/user/public/',
  '/api/shop/public/',
  '/api/categories/public/',
  '/api/socialmedia/public/',
  '/api/localizations/public/',
  '/api/cache/public/',
  '/api/orders/public/',
  '/api/configModuleOrdersWhatsapp/public/',
  '/api/module/public/',
  '/api/shopSubdomain/public/',
];

export function isPublicApiRequest(url = '') {
  return PUBLIC_API_PATTERNS.some((pattern) => url.includes(pattern));
}

export function isAuthError(error) {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    return true;
  }

  const message = error?.response?.data?.message || '';
  if (typeof message === 'string' && message.toLowerCase().includes('token jwt')) {
    return true;
  }

  return false;
}
